import { RouteObject } from "react-router-dom"

export const SET_META = 'SET_META'

export interface MetaState {
	isLoading: boolean
}

export interface MetaAction {
	type: string
	payload: Partial<MetaState>
}


export interface AppRouteHandle {
	hideSidebar?: boolean
}

export type AppRouteObject = RouteObject & {
	handle?: AppRouteHandle
	children?: AppRouteObject[]
}